var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, Icon, InfoOutlineIcon, Text } from 'shared/components';
export var IFrameWarning = function (_a) {
    var children = _a.children;
    return (_jsxs(Flex, __assign({ display: "inline-flex", rounded: "md", color: "info.text", bgColor: "info.light", py: 2, px: 4, whiteSpace: "nowrap", w: "full", "data-testid": "iframeWarningBanner" }, { children: [_jsx(Icon, { fontWeight: "bold", mr: 2, fontSize: "xl", width: "18px", height: "18px", as: InfoOutlineIcon }), _jsx(Text, __assign({ fontWeight: "bold", fontSize: "small" }, { children: children }))] })));
};
